<section class="lg:flex md:sm:grid md:sm:grid-cols-1 gap-4">
    <article class="lg:flex rounded h-10" [ngClass]="{ 'hidden!': collapsed }">
      <app-input-search [placeholder]="placeholder" [searchValue]="searchValue" (submitEventEmitter)="search($event)"></app-input-search>
    </article>
    <article class="relative lg:flex box rounded" [ngClass]="{ 'hidden!': collapsed }" (click)="filterOpened = !filterOpened">
      <button id="buttonOpenFilter"
        class="search-bar-button text-gray-800 font-bold py-2 px-2 rounded inline-flex items-center gap-2"
        [ngClass]="{ 'opened' : filterOpened || filtersApplied > 0, 'filtersApplied': filtersApplied > 0 }">
        <img [src]="images.filter" alt="filter" class="w-6 h-6" [ngClass]="{ 'filter-primary-purple-light': filterOpened }" />
        @if (filtersApplied > 0) {
          <span class="font-bold text-primary-purple-light text-[14px]">
            ({{ filtersApplied }})
          </span>
        }
      </button>
    </article>
    <article class="flex items-center">
      <app-custom-toggle
        [id]="'trips-view-mode-toggle'"
        [selectedValue]="viewMode"
        [options]="viewModeToggleOptions"
        (action)="toggleViewMode()"
      />
    </article>
    <article class="flex absolute left-0 mt-15 w-max max-w-[calc(100vw-8rem)] z-10" [ngClass]="{ 'hidden': !filterOpened || collapsed }">
      <app-filter-panel [componentOpen]="'buttonOpenFilter'" [fields]="filterFields" [filterType]="filterTypes.TRIPS" [pastDatesOnly]="isPositions" (filter)="onFilter($event)" (closeFilter)="filterOpened = false; updateFilters()"></app-filter-panel>
    </article>
    @if (searching && !collapsed) {
      <article class="flex items-center">
        <img [src]="images.loading" alt="loading" class="h-8 w-8 ml-4" />
        <label class="font-semibold text-base ml-4">{{ literalService.get('trips.searchingTrips', true) }}...</label>
      </article>
    }
  </section>

